import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RequestStatus } from "@app/constants";
import { ICreateOrderState } from "./types";

const initialState: ICreateOrderState = {
  createOrder: {},
};

const slice = createSlice({
  name: "brand",
  initialState,
  reducers: {
    createOrders(state, action: PayloadAction) {
      state.createOrder.status = RequestStatus.RUNNING;
    },
    createOrderSuccess(state, action) {
      state.createOrder.status = RequestStatus.SUCCESS;
      state.createOrder.data = action.payload;
    },
    createOrderFailed(state, action: PayloadAction<any>) {
      state.createOrder.status = RequestStatus.ERROR;
      state.createOrder.error = action.payload;
    },
    resetCreateOrder(state) {
      state.createOrder = initialState.createOrder;
    },
  },
});

export default slice.reducer;
export const {
  createOrders,
  createOrderSuccess,
  createOrderFailed,
  resetCreateOrder,
} = slice.actions;
